
function showMessage(type, message){
    // return `<div class="alert alert-${type} alert dismissible fade show" role="alert">
    // <strong>${message}</strong>
    // <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    // </div>`;

    return `<div class="col-md-3 badge-overlay position-absolute top-0 end-0 mt-2 me-2 ">
        <div class="alert alert-${type} alert-dismissible fade show position-relative" id="autoDismissAlert"
            role="alert">
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            <!-- Timer Line -->
            <div class="progress-bar-timer"></div>
        </div> 
        </div>`
}

window.showMessage = showMessage;